/*
class ProductCardButton {
  constructor(cardWrapper) {
    this.cardWrapper = cardWrapper;
    this.sizeSelect = cardWrapper.querySelector('.card-size-select');
    this.button = cardWrapper.querySelector('input[type="button"]');
    
    this.handleMouseLeave = this.handleMousefLeave.bind(this);
    this.handleButtonClick = this.handleButtonClick.bind(this);

    this.initEvents();
  }

  initEvents() {
    if (this.cardWrapper) {
      this.cardWrapper.addEventListener('mouseleave', this.handleMouseLeave);
    }

    if (this.button) {
      this.button.addEventListener('click', this.handleButtonClick);
    }
  }

  handleMouseLeave() {
    if (this.sizeSelect) {
      this.sizeSelect.classList.remove('show');
    }
  }

  handleButtonClick() {
    const productId = this.button.closest('.card-button').getAttribute('data-product-id');
    const sizeSelect = document.querySelector('.card-size-select[data-product-id="' + productId + '"]');

    if (sizeSelect) {
      sizeSelect.classList.add('show');
    }
  }
}

  document.addEventListener("DOMContentLoaded", function() {
    const cardWrappers = document.querySelectorAll('.card-wrapper');
  
    cardWrappers.forEach(cardWrapper => {
      new ProductCardButton(cardWrapper);
  });
});

function initializeProductCardButtons() {
  const cardWrappers = document.querySelectorAll('.card-wrapper');

  cardWrappers.forEach(cardWrapper => {
    new ProductCardButton(cardWrapper);
  });
}

document.addEventListener("DOMContentLoaded", function() {
  initializeProductCardButtons();
});
*/

class ProductCardButton {
  constructor(cardWrapper) {
    this.cardWrapper = cardWrapper;
    //this.sizeSelect = cardWrapper.querySelector('.card-size-select');
    this.sizeSelects = cardWrapper.querySelectorAll(".card-size-select");
    this.button = cardWrapper.querySelector('input[type="button"]');
    this.selectedFinish = null;
    this.selectedSize = null;

    this.handleMouseLeave = this.handleMouseLeave.bind(this);
    this.handleButtonClick = this.handleButtonClick.bind(this);
    this.handleSizeSelect = this.handleSizeSelect.bind(this);

    this.initEvents();
  }

  initEvents() {
    if (this.cardWrapper) {
      this.cardWrapper.addEventListener("mouseleave", this.handleMouseLeave);
    }

    if (this.button) {
      this.button.addEventListener("click", this.handleButtonClick);
    }

    const sizeItems = this.cardWrapper.querySelectorAll(".size-select-item");
    sizeItems.forEach((item) => {
      item.addEventListener("click", this.handleSizeSelect);
    });
  }

  handleMouseLeave() {
    /*
    if (this.sizeSelect) {
      this.sizeSelect.classList.remove('show');
    }*/
    /*const productId = this.button.closest('.card-button').getAttribute('data-product-id');
    const sizeSelects = document.querySelectorAll('.card-size-select[data-product-id="' + productId + '"]');*/

    const sizeSelects = document.querySelectorAll(".card-size-select");
    sizeSelects.forEach((sizeSelect) => sizeSelect.classList.remove("show"));
  }

  handleButtonClick() {
    const productId = this.button
      .closest(".card-button")
      .getAttribute("data-product-id");
    //const sizeSelect = document.querySelector('.card-size-select[data-product-id="' + productId + '"]');
    const sizeSelects = document.querySelectorAll(
      '.card-size-select[data-product-id="' + productId + '"]'
    );
    console.log("handleButtonClick");

    sizeSelects.forEach((sizeSelect) => sizeSelect.classList.add("show"));

    /*
    if (sizeSelect) {
      sizeSelect.classList.add('show');
    }*/
  }

  handleSizeSelect(event) {
    event.preventDefault();
    this.selectedSize = event.target.getAttribute("data-variant-id");
    this.updateVariantId();
  }

  updateVariantId() {
    if (this.selectedFinish && this.selectedSize) {
      const combinedVariantId = `${this.selectedFinish}-${this.selectedSize}`;
      const addToCartButton = this.cardWrapper.querySelector(".card-button");
      addToCartButton.setAttribute("data-variant-id", combinedVariantId);

      console.log(`Selected variant ID: ${combinedVariantId}`);
    }
  }

  setFinish(finishVariantId) {
    this.selectedFinish = finishVariantId;
    this.updateVariantId();
  }
}

document.addEventListener("DOMContentLoaded", function () {
  const cardWrappers = document.querySelectorAll(".card-wrapper");
  cardWrappers.forEach((cardWrapper) => {
    new ProductCardButton(cardWrapper);
  });
});

function initializeProductCardButtons() {
  const cardWrappers = document.querySelectorAll(".card-wrapper");
  cardWrappers.forEach((cardWrapper) => {
    new ProductCardButton(cardWrapper);
  });

  document
    .querySelectorAll(".card-button.add-to-cart-button")
    .forEach((cardButton) => {
      cardButton.addEventListener("click", handleAddToCart);
    });

  document.querySelectorAll(".size-select-item").forEach((sizeButton) => {
    if (sizeButton.getAttribute("data-is-available") === "true") {
      sizeButton.addEventListener("click", handleAddToCart);
    } else {
      sizeButton.addEventListener("click", (event) => {
        event.preventDefault();
        window.location.href = sizeButton.href;
      });
    }
  });
}

document.addEventListener("DOMContentLoaded", function () {
  initializeProductCardButtons();
});

async function handleAddToCart(event) {
  event.preventDefault();
  const button = event.currentTarget;
  /*console.log(button);*/
  const variantId = button.getAttribute("data-variant-id");

  try {
    /*updateButtonState(button, 'Adding...', true);*/
    const response = await addItemToCart(variantId);

    /*updateButtonState(button, '✔', false);*/
    updateCart();
    /*location.reload();*/
  } catch (error) {
    console.error("Error adding to cart:", error);
    updateButtonState(button, "Error! Try again.", false);
  }
}

async function updateCart() {
  try {
    const response = await fetch("/?section_id=cart-drawer");
    const text = await response.text();
    const parser = new DOMParser();
    const doc = parser.parseFromString(text, "text/html");
    const newCartDrawer = doc.querySelector("cart-drawer");
    if (newCartDrawer) {
      const cartDrawer = document.querySelector("cart-drawer");
      cartDrawer.innerHTML = newCartDrawer.innerHTML;

      if (newCartDrawer.querySelector(".cart-item")) {
        cartDrawer.classList.remove("is-empty");
      } else {
        cartDrawer.classList.add("is-empty");
      }
    }

    fetch("/cart.js")
      .then((response) =>
        response.ok
          ? response.json()
          : Promise.reject("Failed to fetch cart data")
      )
      .then((cart) => {
        const countBubble = document.querySelector(".cart-count-bubble");
        if (!countBubble) return console.warn("Cart count bubble not found.");

        const [visibleCount, screenReaderCount] =
          countBubble.querySelectorAll("span");
        if (visibleCount) visibleCount.textContent = cart.item_count;
        if (screenReaderCount)
          screenReaderCount.textContent = `${cart.item_count} items`;
      })
      .catch((error) => console.error("Error updating cart count:", error));
    // document
    //   .querySelector("#cart-icon-bubble")
    //   ?.dispatchEvent(new Event("click", { bubbles: true }));
    document.querySelector("cart-drawer").open();
  } catch (error) {
    console.error("Error updating cart:", error);
  }
}

async function addItemToCart(variantId) {
  const response = await fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ id: variantId, quantity: 1 }),
  });
  if (!response.ok) throw new Error("Failed to add to cart");
  return response.json();
}

function updateButtonState(button, text, isLoading) {
  button.textContent = text;
  button.disabled = isLoading;
  button.classList.toggle("loading", isLoading);
}
